<template>
	<div class="broker-dashboard">

		<!-- Dashboard Widgets Grid - Using common dashboard classes -->
		<div class="dashboard__grid">
			<!-- Active Projects Widget -->
			<div class="dashboard__widget">
				<div class="dashboard__card">
					<active-projects-widget
						:chart-data="activeProjectsChartData"
					/>
				</div>
			</div>

			<!-- Tours Widget -->
			<div class="dashboard__widget">
				<div class="dashboard__card">
					<broker-tours-widget
						:tours="tours"
					/>
				</div>
			</div>
		</div>

		<!-- Properties Table -->
		<div class="dashboard__table-section">
			<properties-table
				:projects="projects"
				:sites="sites"
			/>
		</div>
	</div>
</template>

<script>
import PropertiesTable from '../dashboard/PropertiesTable.vue';
import ActiveProjectsWidget from '../dashboard/ActiveProjectsWidget.vue';
import BrokerToursWidget from './BrokerToursWidget.vue';

export default {
	name: 'BrokerDashboard',
	
	components: {
		PropertiesTable,
		ActiveProjectsWidget,
		BrokerToursWidget
	},
	
	props: {
		sites: {
			type: Array,
			required: true
		},
		projects: {
			type: Array,
			required: true
		},
		tours: {
			type: Array,
			default: () => []
		},
		stats: {
			type: Object,
			required: true
		},
		activeProjectsChartData: {
			type: String,
			required: true
		}
	}
}
</script>
